// extracted by mini-css-extract-plugin
export default {"linkBase":"linkBase-b746","disabled":"disabled-aa93"};